<template>
    <div id="stage" :class="currentShow !== 'res-brainstorm-1' ? 'overflow' : ''">
        <!-- <div @click="addAudioData" id="button">点击发送答疑show</div>
        <div @click="wait" id="button" style="top:700px">点击返回waiting</div> -->
        <!-- success -->
        <success id="success" v-visible="currentShow === 'success'" :current-show="currentShow" class="success"></success>

        <!-- just waiting -->
        <waiting id="waiting" v-visible="currentShow === 'waiting'" :current-show="currentShow" class="waiting" />

        <!-- just nonsupport -->
        <nonsupport id="nonsupport" v-visible="currentShow === 'nonsupport'" :current-show="currentShow" class="nonsupport" />

        <noController id="noController" v-visible="currentShow === 'noController'" class="noController" />

        <resourceImage id="res-img-1" v-visible="currentShow === 'res-img-1'" :current-show="currentShow" :is-lock="isLock" />
        <resourceImage id="res-img-2" v-visible="currentShow === 'res-img-2'" :current-show="currentShow" :is-lock="isLock" />

        <resourcePDF id="res-pdf-1" v-visible="currentShow === 'res-pdf-1'" :current-show="currentShow" :is-lock="isLock" />
        <resourcePDF id="res-pdf-2" v-visible="currentShow === 'res-pdf-2'" :current-show="currentShow" :is-lock="isLock" />

        <resourceAudio id="res-audio-1" v-visible="currentShow === 'res-audio-1'" :current-show="currentShow" :is-lock="isLock" />
        <resourceAudio id="res-audio-2" v-visible="currentShow === 'res-audio-2'" :current-show="currentShow" :is-lock="isLock" />

        <resourceVideo id="res-video-1" v-visible="currentShow === 'res-video-1'" :current-show="currentShow" :is-lock="isLock" />
        <resourceVideo id="res-video-2" v-visible="currentShow === 'res-video-2'" :current-show="currentShow" :is-lock="isLock" />
        
        <resourceHTML id="res-html-1" v-visible="currentShow === 'res-html-1'" :current-show="currentShow" :is-lock="isLock" />
        <resourceHTML id="res-html-2" v-visible="currentShow === 'res-html-2'" :current-show="currentShow" :is-lock="isLock" />
        
        <resourceText id="res-text-1" v-visible="currentShow === 'res-text-1'" :current-show="currentShow" :is-lock="isLock"/>
        <!-- <resourceText id="res-text-2" v-visible="currentShow === 'res-text-2'" :current-show="currentShow" :is-lock="isLock"/> -->

        <!-- storm -->
        <activityStorm id="act-storm-1" v-visible="currentShow === 'act-storm-1'" :current-show="currentShow" :is-lock="isLock" :user-id="userId" />

        <activityQuiz id="act-quiz-1" v-visible="currentShow === 'act-quiz-1'" :current-show="currentShow" :is-lock="isLock" />
        
        <!-- vote -->
        <activityVote id="act-vote-1" v-visible="currentShow === 'act-vote-1'" :current-show="currentShow" :is-lock="isLock" />
        
        <homework id="hw-1" v-if="currentShow === 'hw-1'" :current-show="currentShow" :is-lock="isLock" />
        
        <!-- qa -->
        <qa id="qa-1" v-if="currentShow === 'qa-1'" :current-show="currentShow" :is-lock="isLock" :user-id="userId" />
        
        <!-- checkin -->
        <checkin id="checkin-1" v-visible="currentShow === 'checkin-1'" :current-show="currentShow" :is-lock="isLock" />

        <!-- choose -->
        <choose id="choose-1" v-visible="currentShow === 'choose-1'" :current-show="currentShow" :is-lock="isLock" :version="version"/>

        <!-- group -->
        <group id="group-1" v-visible="currentShow === 'group-1'" :current-show="currentShow" :is-lock="isLock" />

        <!-- race -->
        <race id="race-1" v-visible="currentShow === 'race-1'" :current-show="currentShow" :is-lock="isLock" />

        <!-- handUp -->
        <handUp id="hand-up-1" v-visible="currentShow === 'hand-up-1'" :current-show="currentShow" :is-lock="isLock" />

        <!-- bookLearn -->
        <bookLearn id="book-learn" v-visible="currentShow === 'book-learn'" :current-show="currentShow" :is-lock="isLock" />

        <toast v-show="toastText && toastText.length > 0" id="toast-layer" :toast-text="toastText" />
    </div>
</template>

<script>
import qaJson from '@/assets/json/qa.json';


import io from 'socket.io-client';

import waiting from '@/components/waiting.vue';
import success from '@/components/linkSuccess.vue';
import nonsupport from '@/components/nonsupport.vue';
import toast from '@/components/toast.vue';
import resourcePDF from '@/components/resourcePDF.vue';
import resourceAudio from '@/components/resourceAudio.vue';
import resourceVideo from '@/components/resourceVideo.vue';
import resourceHTML from '@/components/resourceHTML.vue';
import resourceImage from '@/components/resourceImage.vue';
import resourceText from '@/components/resourceText.vue';
import noController from '@/components/noController.vue';
import activityStorm from '@/components/activityStorm.vue';
import activityVote from '@/components/activityVote.vue';
import activityQuiz from '@/components/activityQuiz.vue';
import checkin from '@/components/checkin.vue';
import choose from '@/components/crpChoose.vue';
import group from '@/components/crpGroup.vue';
import race from '@/components/crpRaceHandUp.vue';
import handUp from '@/components/crpHandUp.vue';
import homework from '@/components/homework.vue';
import bookLearn from '@/components/bookLearn';
import qa from '@/components/qa.vue';

import tool from '@/assets/scripts/tool.js';

export default {
    components: {
        success,
        waiting,
        toast,
        noController,
        resourcePDF,
        resourceAudio,
        resourceHTML,
        resourceVideo,
        resourceImage,
        resourceText,
        activityStorm,
        activityVote,
        activityQuiz,
        homework,
        bookLearn,
        nonsupport,
        checkin,
        choose,
        group,
        race,
        handUp,
        qa
    },

    data: function() {
        return {
            token: sessionStorage.getItem('__token'),
            userId: '',
            isLock: false,
            currentShow: 'success',
            stageType: 'success',
            $socket: null,
            toastText: null,
            toastTimerId: 0,
            toastLayer: null,
            version: '4', // 选人模块需要兼容之前版本，加一个表示区分版本 默认为旧版本 新版本为5
            keepTokenAlive: null,
        };
    },

    created: function() {
        if (this.$route.params.from === 'username-password-login') {
            this.currentShow = 'noController';
        }

        let currentSocketId = null;
        this.$socket = io(process.env.VUE_APP_SOCKET_IO_ENDPOINT, {
            transports: ['websocket'],
            reconnection: false
        });

        if (!this.token) {
            this.$router.push({path: '/'});
        }

        // 连接到socket.Io
        this.$socket.on('connect', () => {
            console.log('connected to socket.io server:', this.$socket.id, ', going to auth by token');
            currentSocketId = this.$socket.id;
            this.$socket.emit('passport.auth-by-token', {token: this.token}, (ackData) => {
                if (ackData && ackData.result) {
                    // nothing to do
                    console.log('user ', ackData.user.fullName, ' is logged in with token ', this.token, ackData);
                    
                    this.userId = ackData.user && ackData.user.id;
                    // keep-token-alive
                    this.keepTokenAlive = setInterval(() => {
                        this.$socket.emit('common.keep-token-alive',() => {
                            console.log('the token is keep alive');
                        });
                    },30000);
                } else {
                    sessionStorage.removeItem('__token');
                    this.$socket.disconnect();
                    this.$socket = null;
                    this.$router.push({path: '/'});
                }
            });

        });

        this.$socket.on('disconnect', () => {
            console.log('disconnect from socket.io server:', currentSocketId);
            currentSocketId = null;
            clearInterval(this.keepTokenAlive);
        });

        // 收到进入等待屏指令
        this.$socket.on('common.waiting', (toWaiting) => {
            if (this.isLock) return;
            this.currentShow = 'waiting';
            window.postMessage({
                eventName: 'common.waiting',
                data: toWaiting
            }, tool.getOrigin());
        });
        
        // 是否收到控制端下线指令
        this.$socket.on('controller.offline', (offlineData) => {
            this.currentShow = 'noController';
            clearInterval(this.keepTokenAlive);
        });

        // 收到控制端上线指令
        this.$socket.on('controller.online', (onlineData) => {
            this.currentShow = 'success';
        });

        // 收到控制端退出投屏
        this.$socket.on('controller.exit', (exitData) => {
            this.resetSetItem('__token', '');
            sessionStorage.clear();
            this.$router.push({path: '/'});
            clearInterval(this.keepTokenAlive);
        });

        // 收到控制端强制断开
        this.$socket.on('common.killByController', (exitData) => {
            this.resetSetItem('__token', '');
            sessionStorage.clear();
            this.$router.push({path: '/'});
            clearInterval(this.keepTokenAlive);
        });

        // 进入投屏端的角色
        this.$socket.on('common.enterCC', (data) => {
            this.currentShow = 'waiting';
            window.postMessage({
                eventName: 'common.enterCC',
                data: data,
            }, tool.getOrigin());
        });

        // 离开班课
        this.$socket.on('common.leaveCC', (data) => {
            this.currentShow = 'success';
        });

        // 摇杆
        this.$socket.on('common.moveJoystick', (data) => {
            window.postMessage({
                eventName: 'common.moveJoystick',
                data: data,
            }, tool.getOrigin());
        });

        // Enter locking mode
        this.$socket.on('common.lock', () => {
            this.isLock = true;
        });

        this.$socket.on('common.unlock', () => {
            this.isLock = false;
        });

        // 资源以及附件消息show
        this.$socket.on('files.show', (fileData) => {
            let fileType = fileData.type;
            let data = fileData.data;
            switch (fileType) {
                case 'RESOURCE':
                    console.log('收到新资源类型');
                    if (! this.isLock) this.showResourceView(data);
                    window.postMessage({
                        eventName: 'resource.show',
                        data: data,
                    }, tool.getOrigin());
                    break;
                case 'QUIZ':
                    // console.log('收到测试附件',fileData);
                    if (this.isLock) return;
                    window.postMessage({
                        eventName: 'quiz.files.show',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'HOMEWORK/HOMEWORK_ANSWER':
                    // if (this.isLock) return;
                    window.postMessage({
                        eventName: 'hw.files.show',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'HOMEWORK_RESULT':
                    // if (this.isLock) return;
                    window.postMessage({
                        eventName: 'hw.files.show',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'STORM':
                    window.postMessage({
                        eventName: 'activity.storm.showDetailImage',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'STORM_RESULT':
                    window.postMessage({
                        eventName: 'activity.storm.showResultImage',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'QA_MSG':
                    window.postMessage({
                        eventName: 'activity.qa.showFiles',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'QA_REF_MSG':
                    window.postMessage({
                        eventName: 'activity.qa.showRefFiles',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                default:
                    // statements_def
                    break;
            }
            
        });

        // 资源以及附件消息hide
        this.$socket.on('files.hide', (fileData) => {
            let fileType = fileData.type;
            switch (fileType) {
                case 'STORM':
                    window.postMessage({
                        eventName: 'activity.storm.hideDetailImage',
                        data: fileData
                    }, tool.getOrigin());
                    break;
                case 'QUIZ':
                    if (this.isLock) return;
                    window.postMessage({
                        eventName: 'quiz.audio.hide',
                        data: fileData
                    }, tool.getOrigin());
                    break;
                case 'HOMEWORK/HOMEWORK_ANSWER':
                    // if (this.isLock) return;
                    window.postMessage({
                        eventName: 'hw.files.hide',
                        data: fileData
                    }, tool.getOrigin());
                    break;
                case 'HOMEWORK_RESULT':
                    // if (this.isLock) return;
                    window.postMessage({
                        eventName: 'hw.files.hide',
                        data: fileData
                    }, tool.getOrigin());
                    break;
                case 'STORM_RESULT':
                    window.postMessage({
                        eventName: 'activity.storm.hideResultImage',
                        data: fileData
                    }, tool.getOrigin());
                    break;
                case 'QA_MSG':
                    window.postMessage({
                        eventName: 'activity.qa.hideFiles',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                case 'QA_REF_MSG':
                    window.postMessage({
                        eventName: 'activity.qa.hideRefFiles',
                        data: fileData,
                    }, tool.getOrigin());
                    break;
                default:
                    // statements_def
                    break;
            }
            
        });

        // 资源下一页
        this.$socket.on('files.pageNext', (pageNextData) => {
            // console.log(pageNextData);
            window.postMessage({
                eventName: 'files.pageNext',
                data: pageNextData
            }, tool.getOrigin());
        }),

        // 资源上一页
        this.$socket.on('files.pagePrev', (pagePrevData) => {
            window.postMessage({
                eventName: 'files.pagePrev',
                data: pagePrevData
            }, tool.getOrigin());
        }),

        // 资源指定页
        this.$socket.on('files.pageGoto', (pageGotoData) => {
            window.postMessage({
                eventName: 'files.pageGoto',
                data: pageGotoData
            }, tool.getOrigin());
        }),

        // zoom in/out resource/attachment
        this.$socket.on('files.zoom', (data) => {
            let type = data.type;
            window.postMessage({
                eventName: 'files.zoom',
                data: data
            }, tool.getOrigin());
        });

        // img rotate
        this.$socket.on('files.rotate', (data) => {
            let type = data.type;
            window.postMessage({
                eventName: 'files.rotate',
                data: data
            }, tool.getOrigin());
        });

        // 收到暂停指令
        this.$socket.on('files.pause', (pauseData) => {
            if (this.isLock) return;
            let type = pauseData.type;
            console.log('收到暂停指令');
            // 将收到的暂停指令写入postMessag
            window.postMessage({
                eventName: 'files.pause',
                data: pauseData,
            }, tool.getOrigin());
        });

        // 收到播放指令
        this.$socket.on('files.play', (playData) => {
            console.log('收到播放指令');
            let type = playData.type;
            window.postMessage({
                eventName: 'files.play',
                data: playData,
            }, tool.getOrigin());
        });

        // 收到调整音量指令
        this.$socket.on('files.volume', (volumeData) => {
            console.log('收到调整音量指令');
            window.postMessage({
                eventName: 'files.volume',
                data: volumeData,
            }, tool.getOrigin());
        });

        // 收到音频跳转指令
        this.$socket.on('files.jump', (jumpData) => {
            console.log('收到音频跳转指令');
            let type = jumpData.type;
            if (this.isLock && this.currentShow === 'hw-1') return;
            window.postMessage({
                eventName: 'files.jump',
                data: jumpData,
            }, tool.getOrigin());
        });

        //头脑风暴指令
        this.$socket.on('activity.storm.show',(brainstorm) => {
            // console.log(brainstorm);
            if (! this.isLock) this.showActivityStorm(brainstorm);
            window.postMessage({
                eventName: 'activity.storm.show',
                data: brainstorm,
            }, tool.getOrigin());
        });

        // 头脑风暴是否收到新的提交结果
        this.$socket.on('activity.storm.newResult',(newBrainstorm) => {
            window.postMessage({
                eventName: 'activity.storm.newResult',
                data: newBrainstorm,
            }, tool.getOrigin());
        }),

        // 头脑风暴点赞情况
        this.$socket.on('activity.storm.like',(stormLikeData) => {
            window.postMessage({
                eventName: 'activity.storm.like',
                data: stormLikeData,
            }, tool.getOrigin());
        }),

        this.$socket.on('activity.storm.showDetail', (data) => {
            window.postMessage({
                eventName: 'activity.storm.showDetail',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.hideDetail', (data) => {
            window.postMessage({
                eventName: 'activity.storm.hideDetail',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.showResult', (data) => {
            window.postMessage({
                eventName: 'activity.storm.showResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.hideResult', (data) => {
            window.postMessage({
                eventName: 'activity.storm.hideResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.addTag', (data) => {
            window.postMessage({
                eventName: 'activity.storm.addTag',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.removeTag', (data) => {
            window.postMessage({
                eventName: 'activity.storm.removeTag',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.selectTag', (data) => {
            window.postMessage({
                eventName: 'activity.storm.selectTag',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.storm.intelliTag', (data) => {
            window.postMessage({
                eventName: 'activity.storm.intelliTag',
                data: data
            }, tool.getOrigin()); 
        });

        // 头脑风暴取消点赞情况
        this.$socket.on('activity.storm.cancelLike', (stormCanceLikeData) => {
            window.postMessage({
                eventName: 'activity.storm.cancelLike',
                data: stormCanceLikeData,
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.show', (data) => {
            if (this.isLock) return;
            this.showActivityQuiz(data);
            window.postMessage({
                eventName: 'activity.quiz.show',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.showTopic', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.showTopic',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.showUserResult', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.showUserResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.showAnalyze', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.showAnalyze',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.showTopicAnalyze', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.showTopicAnalyze',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.newResult', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.newResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('activity.quiz.sortBy', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.quiz.sortBy',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.start', (data) => {
            if (this.isLock) return;
            this.currentShow = 'checkin-1';
            window.postMessage({
                eventName: 'checkin.start',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.showPoints', (data) => {
            if (this.currentShow !== 'checkin-1') return;
            window.postMessage({
                eventName: 'checkin.showPoints',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.hidePoints', (data) => {
            if (this.currentShow !== 'checkin-1') return;
            window.postMessage({
                eventName: 'checkin.hidePoints',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.updateMembers', (data) => {
            if (this.currentShow !== 'checkin-1') return;
            window.postMessage({
                eventName: 'checkin.updateMembers',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.end', (data) => {
            if (this.currentShow !== 'checkin-1') return;
            window.postMessage({
                eventName: 'checkin.end',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('checkin.checked', (data) => {
            if (this.currentShow !== 'checkin-1') return;
            window.postMessage({
                eventName: 'checkin.checked',
                data: data
            }, tool.getOrigin());
        });

        // 调整字号指令
        this.$socket.on('common.fontsize', (fontData) => {
            window.postMessage({
                eventName: 'common.fontsize',
                data: fontData
            }, tool.getOrigin());
        });

        //投票问券指令
        this.$socket.on('activity.vote.show',(vote) => {
            if (! this.isLock) this.showActivityVote(vote);
            window.postMessage({
                eventName: 'activity.vote.show',
                data: vote,
            }, tool.getOrigin());
        });

        this.$socket.on('activity.vote.showTopic',(data) => {
            window.postMessage({
                eventName: 'activity.vote.showTopic',
                data: data,
            }, tool.getOrigin());
        });

        this.$socket.on('activity.vote.sortBy',(data) => {
            window.postMessage({
                eventName: 'activity.vote.sortBy',
                data: data,
            }, tool.getOrigin());
        });

        this.$socket.on('activity.vote.newResult', (data) => {
            window.postMessage({
                eventName: 'activity.vote.newResult',
                data: data,
            }, tool.getOrigin());
        });

        this.$socket.on('hw.showResults', (data) => {
            if (!this.isLock) {
                if (this.currentShow !== 'hw-1') this.currentShow = 'hw-1';
            };
            window.postMessage({
                eventName: 'hw.showResults',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.filterResults', (data) => {
            window.postMessage({
                eventName: 'hw.filterResults',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.sortResults', (data) => {
            window.postMessage({
                eventName: 'hw.sortResults',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.expandResultText', (data) => {
            window.postMessage({
                eventName: 'hw.expandResultText',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.collapseResultText', (data) => {
            window.postMessage({
                eventName: 'hw.collapseResultText',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.viewResultText', (data) => {
            window.postMessage({
                eventName: 'hw.viewResultText',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.hideResultText', (data) => {
            window.postMessage({
                eventName: 'hw.hideResultText',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.resultScoreChanged', (data) => {
            window.postMessage({
                eventName: 'hw.resultScoreChanged',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.rejectResult', (data) => {
            window.postMessage({
                eventName: 'hw.rejectResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.newResult', (data) => {
            window.postMessage({
                eventName: 'hw.newResult',
                data: data
            }, tool.getOrigin());
        });

        this.$socket.on('hw.commentCountChanged', (data) => {
            window.postMessage({
                eventName: 'hw.commentCountChanged',
                data: data
            }, tool.getOrigin());
        });

        // 选人
        this.$socket.on('crp.chooseMembers.start', (data) => {
            if (this.isLock) return;
            this.version = '4';
            this.showCrpChoose(data);
            window.postMessage({
                eventName: 'crp.chooseMembers.start',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.setMembers', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.setMembers',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.enterRandom', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.enterRandom',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.playRandom', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.playRandom',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.exitRandom', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.exitRandom',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.setScore', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.setScore',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.chooseMembers.end', (data) => {
            window.postMessage({
                eventName: 'crp.chooseMembers.end',
                data: data
            },tool.getOrigin());
        });

        //小组评价
        this.$socket.on('crp.groupEvaluate.start', (data) => {
            if (this.isLock) return;
            this.showCrpGroup(data);
            window.postMessage({
                eventName: 'crp.groupEvaluate.start',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.groupEvaluate.chosenGroup', (data) => {
            window.postMessage({
                eventName: 'crp.groupEvaluate.chosenGroup',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.groupEvaluate.removeMember', (data) => {
            window.postMessage({
                eventName: 'crp.groupEvaluate.removeMember',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.groupEvaluate.setScore', (data) => {
            window.postMessage({
                eventName: 'crp.groupEvaluate.setScore',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.groupEvaluate.end', (data) => {
            window.postMessage({
                eventName: 'crp.groupEvaluate.end',
                data: data
            },tool.getOrigin());
        });

        //抢答
        this.$socket.on('crp.raceHandUp.start', (data) => {
            if (this.isLock) return;
            this.showCrpRaceHandUp(data);
            window.postMessage({
                eventName: 'crp.raceHandUp.start',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.startUp', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.startUp',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.attend', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.attend',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.enterScore', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.enterScore',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.removeMember', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.removeMember',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.setScore', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.setScore',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.raceHandUp.end', (data) => {
            window.postMessage({
                eventName: 'crp.raceHandUp.end',
                data: data
            },tool.getOrigin());
        });

        //举手
        this.$socket.on('crp.handUp.start', (data) => {
            if (this.isLock) return;
            this.showCrpHandUp(data);
            window.postMessage({
                eventName: 'crp.handUp.start',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.startUp', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.startUp',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.attend', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.attend',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.chooseMember', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.chooseMember',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.cancelChooseMember', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.cancelChooseMember',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.setMembers', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.setMembers',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.removeMember', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.removeMember',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.setScore', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.setScore',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('crp.handUp.end', (data) => {
            window.postMessage({
                eventName: 'crp.handUp.end',
                data: data
            },tool.getOrigin());
        });

        // 答疑讨论
        this.$socket.on('activity.qa.show', (data) => {
            if (!this.isLock) this.currentShow = 'qa-1';
            window.postMessage({
                eventName: 'activity.qa.show',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.showHistory', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.qa.showHistory',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.showTopic', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.qa.showTopic',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.hideTopic', (data) => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'activity.qa.hideTopic',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.revokeMsg', (data) => {
            window.postMessage({
                eventName: 'activity.qa.revokeMsg',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.sendMsg', (data) => {
            window.postMessage({
                eventName: 'activity.qa.sendMsg',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.like', (data) => {
            window.postMessage({
                eventName: 'activity.qa.like',
                data: data
            },tool.getOrigin());
        });

        this.$socket.on('activity.qa.cancelLike', (data) => {
            window.postMessage({
                eventName: 'activity.qa.cancelLike',
                data: data
            },tool.getOrigin());
        });

        // 5.0新加指令 
        // 进入手动选人页面
        this.$socket.on('crp.chooseManual.enter', (data) => {
            if (this.isLock) return;
            this.version = '5';
            this.showCrpChoose();
            window.postMessage({
                eventName: 'crp.chooseManual.enter',
                data: data
            },tool.getOrigin());
        });

        // 手动选人设置选中的成员
        this.$socket.on('crp.chooseManual.setMembers', data => {
            window.postMessage({
                eventName: 'crp.chooseManual.setMembers',
                data: data
            },tool.getOrigin());
        });

        // 手动选人设置得分
        this.$socket.on('crp.chooseManual.setScore', data => {
            window.postMessage({
                eventName: 'crp.chooseManual.setScore',
                data: data
            },tool.getOrigin());
        });

        // 手动选人结束
        this.$socket.on('crp.chooseManual.end', data => {
            window.postMessage({
                eventName: 'crp.chooseManual.end',
                data: data
            },tool.getOrigin());
        });

        // 进入随机选人页面
        this.$socket.on('crp.chooseRandom.enter', data => {
            if (this.isLock) return;
            this.version = '5'; 
            this.showCrpChoose();
            window.postMessage({
                eventName: 'crp.chooseRandom.enter',
                data: data
            },tool.getOrigin());
        });

        // 随机选人开始摇一摇
        this.$socket.on('crp.chooseRandom.play', data => {
            window.postMessage({
                eventName: 'crp.chooseRandom.play',
                data: data
            },tool.getOrigin());
        });

        // 随机选人设置选中的成员
        this.$socket.on('crp.chooseRandom.setMembers', data => {
            window.postMessage({
                eventName: 'crp.chooseRandom.setMembers',
                data: data
            },tool.getOrigin());
        });

        // 随机选人设置得分
        this.$socket.on('crp.chooseRandom.setScore', data => {
            window.postMessage({
                eventName: 'crp.chooseRandom.setScore',
                data: data
            },tool.getOrigin());
        });

        // 随机选人结束
        this.$socket.on('crp.chooseRandom.end', data => {
            window.postMessage({
                eventName: 'crp.chooseRandom.end',
                data: data
            },tool.getOrigin());
        });

        // 进入云教材活动
        this.$socket.on('booklearn.showResults', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.showResults',
                data: data
            },tool.getOrigin());
            this.currentShow = 'book-learn';
        });

        // 显示云教材任务详情
        this.$socket.on('booklearn.showDetail', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.showDetail',
                data: data
            },tool.getOrigin());
            this.currentShow = 'book-learn';
        });

        // 隐藏云教材任务详情
        this.$socket.on('booklearn.hideDetail', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.hideDetail',
                data: data
            },tool.getOrigin());
        });

        // 云教材学习结果进行排序
        this.$socket.on('booklearn.sortResults', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.sortResults',
                data: data
            },tool.getOrigin());
        });

        // 学生学习报告 - 显示
        this.$socket.on('booklearn.report.show', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.report.show',
                data: data
            },tool.getOrigin());
            this.currentShow = 'book-learn';
        });

        // 学生学习报告 - 隐藏
        this.$socket.on('booklearn.report.hide', data => {
            if (this.isLock) return;
            window.postMessage({
                eventName: 'booklearn.report.hide',
                data: data
            },tool.getOrigin());
        });

    },

    mounted: function() {
        window.addEventListener('message', this.windowMessageHandler);
        this.toastLayer = document.querySelector('#toast-layer');
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
        if (this.$socket) this.$socket.disconnect();
        this.toastLayer = null;
    },

    methods: {
        /**
         * Switch to resource view according to the resource mime type or other properties
         * @param {object} res the resource data received from socket
         * @return {void}
         */
        showResourceView: function(res) {
            let mimeType = res.mimeType;
            let previewableDocument = res.previewableDocument;
            if (! mimeType) mimeType = 'unknown';
            mimeType = mimeType.toLowerCase();
            if (mimeType.startsWith('image/')) {
                this.currentShow = this.currentShow === 'res-img-1' ? 'res-img-2' : 'res-img-1';
            } else if (mimeType.startsWith('audio/')) {
                this.currentShow = this.currentShow === 'res-audio-1' ? 'res-audio-2' : 'res-audio-1';
            } else if (mimeType === 'application/x-mpegurl' || mimeType.startsWith('video/')) {
                this.currentShow = this.currentShow === 'res-video-1' ? 'res-video-2' : 'res-video-1';
            } else if (mimeType === 'mosoink/html') {
                this.currentShow = this.currentShow === 'res-html-1' ? 'res-html-2' : 'res-html-1';
            } else if (mimeType === 'mosoink/url') {
                this.currentShow = 'nonsupport';
            } else if (mimeType === 'text/plain' || tool.getCodeLang(res.extName) != null) {
                // this.currentShow = this.currentShow === 'res-text-1' ? 'res-text-2' : 'res-text-1';
                this.currentShow = 'res-text-1';
            } else {
                if (previewableDocument) {
                    this.currentShow = this.currentShow === 'res-pdf-1' ? 'res-pdf-2' : 'res-pdf-1';
                } else {
                    console.log('无法正常读取文件');
                    this.currentShow = 'nonsupport';
                }
            }
        },

        canPlayTypeToAudio: function(data) {
            
        },

        // 活动类型
        showActivityStorm: function(res) {
            // this.currentShow = this.currentShow === 'res-brainstorm-1' ? 'res-brainstorm-2' : 'res-brainstorm-1';
            this.currentShow = 'act-storm-1';
        },

        //投票问券
        showActivityVote: function(vote) {
            // this.currentShow = this.currentShow === 'vote-1' ? 'vote-2' : 'vote-1';
            this.currentShow = 'act-vote-1';
        },

        showActivityQuiz: function(data) {
            this.currentShow = 'act-quiz-1';
        },

        showCrpChoose: function(data, version) {
            this.currentShow = 'choose-1';
        },

        showCrpGroup: function(data) {
            this.currentShow = 'group-1';
        },

        showCrpRaceHandUp: function(data) {
            this.currentShow = 'race-1';
        },

        showCrpHandUp: function(data) {
            this.currentShow = 'hand-up-1';
        },

        /**
         * Show the toast layer
         * @param  {String} s the toast text string
         * @return {void}   
         */
        showToast: function(s) {
            if (! s) return;
            if (this.toastTimerId > 0) {
                clearTimeout(this.toastTimerId);
                this.toastLayer.style.opacity = '1';
            }
            this.toastText = s;
            this.toastTimerId = setTimeout(() => {
                this.toastLayer.style.opacity = '0';
                setTimeout(() => {
                    this.toastText = null;
                }, 400);
            }, 2000);
        },

        // 字号指令
        windowMessageHandler: function(e) {
            let msg = e.data;
            if (!msg.eventName) return;

            let msgData = msg.data;
            console.log(msg.eventName, msgData);
            if (msg.eventName === 'common.fontsize') {
                let htmlDoc = document.querySelector('html');
                if (msgData.fontSize === 'S') {
                    htmlDoc.style.fontSize = '12px';
                    this.showToast('小号字体');
                } else if (msgData.fontSize === 'M') {
                    htmlDoc.style.fontSize = '16px';
                    this.showToast('正常字体');
                } else if (msgData.fontSize === 'L') {
                    htmlDoc.style.fontSize = '24px';
                    this.showToast('大号字体');
                } else if (msgData.fontSize === 'XL') {
                    htmlDoc.style.fontSize = '36px';
                    this.showToast('超大字体');
                } else {
                    return;
                }
            }
        },


        addAudioData: function() {
            this.currentShow = 'qa-1';
            window.parent.postMessage(qaJson,'*');
        },

        wait: function() {
            this.currentShow = 'waiting';
        },

        disableQuiz() {
            this.currentShow = 'nonsupport';
            
            window.postMessage({
                eventName: 'activity.quiz.disable',
                data: {}
            }, tool.getOrigin());
        }
    }
};
</script>

<style scoped>
    #stage {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color: #ffffff;
    }

    .overflow{
        overflow: hidden;
    }

    #stage > div{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #252525;
    }


    #stage #button {
        width: 100px;
        height: 50px;
        background: #cccccc;
        position: fixed;
        top: 500px;
        right: 0px;
        left: 95%;
        z-index: 99999;
    }
</style>


